import {
  Button,
  Heading,
  SpacingToken,
  Text,
} from '@livechat/design-system-react-components'
import { css } from '@emotion/react'

import BulbIcon from '@/assets/icons/bulb.inline.svg'

const headingCss = css`
  margin: var(${SpacingToken.Spacing2}) 0 0 0;
`

const contentCss = css`
  margin-top: var(${SpacingToken.Spacing1});
  margin-bottom: var(${SpacingToken.Spacing3});
`

interface Props {
  onClose: () => void
}

const NotLoggedInTooltip = ({ onClose }: Props) => (
  <div>
    <BulbIcon />

    <Heading as="h3" size="xs" css={headingCss}>
      Rating available for app users
    </Heading>

    <Text css={contentCss}>
      You can rate this app if you are using it currently on your license.
    </Text>

    <Button kind="primary" onClick={onClose}>
      Close
    </Button>
  </div>
)

export default NotLoggedInTooltip
